var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"IncomeExpress"},[_c('slider-question',_vm._b({},'slider-question',{
        title: 'What is your total annual income before tax?',
        min: 0,
        type: 'money',
        format: 'thousands',
        max: 120000,
        tick: 20000,
        step: 1000,
        value: this.$store.state.income,
        customVal: this.$store.state.customIncome,
        name: 'income',
        customName: 'customIncome',
        next: 'results'
    },false)),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }